import { makeStyles } from '@material-ui/core';

export const WrapupStyles = () =>
  makeStyles((theme) => ({
    main_modal_container: {
      padding: '15px 40px',
      [theme.breakpoints.down('650')]: {
        padding: '10px',
      },
    },
    step_two_margin: {
      margin: '20px 0',
    },
    step_two_row: { display: 'block', textAlign: 'center' },
    text_position: {
      width: '68%',
      height: '90px',
      display: 'inline-flex',
      marginTop: '10px',
    },
    text_design: {
      alignItems: 'center',
      width: '100%',
      overflowX: 'hidden',
    },
    text_padding: {
      padding: '0.5em',
    },
    agentWrapupContainer: {
      display: 'inline-flex',
      width: '100%',
      height: '80px',
      justifyContent: 'center',
    },
    wrapupTwoBtn: {
      margin: '0 15px',
      width: '100%',
    },
    iconPadding: {
      padding: '10px 5px',
      maxWidth: '55px',
      maxHeight: '55px',
      width: '100%',
    },
    smileyImg: {
      width: '100%',
      height: '100%',
    },
    rateExperience: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '120%',
    },
    buttonContainer: {
      display: 'flex',
    },
    textFieldsBottomMargin: {
      padding: '10px',
      marginBottom: '10px',
    },
  }));
